import { gql } from '@apollo/client';

const sendDOIConfirmEmail = gql`
  mutation sendDOIConfirmEmail {
    sendDOIConfirmEmail
  }
`;

export default sendDOIConfirmEmail;
